import { Component, OnChanges, OnInit, inject, ChangeDetectionStrategy, signal, input, output } from '@angular/core';
import {GuruEntity} from '../../../model/guru-entity';
import {ConfigurationSection, UserStateService} from '../../../services/user-state.service';
import {ModelService} from '../../../services/model-service';
import {SelectionUtils} from '../../selection-utils';
import { FormsModule } from '@angular/forms';

import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-mega-mod-mechanical-connections',
    templateUrl: './mega-mod-mechanical-connections.component.html',
    styleUrls: ['./mega-mod-mechanical-connections.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatIcon, FormsModule]
})
export class MegaModMechanicalConnectionsComponent implements OnChanges {
  private readonly modelService = inject(ModelService);
  private readonly userStateService = inject(UserStateService);


  readonly invalidEntities = input.required<string[]>();
  readonly engineKey = input.required<string>();
  readonly selectionEntities = input.required<GuruEntity[]>();
  readonly imagePrefix = input.required<string>();
  readonly valueChanged = output<void>();
  returnAirLocationSelection!: GuruEntity;
  paintOptionsSelection!: GuruEntity;
  topSupplySelection!: GuruEntity;
  riserConnectionSelection!: GuruEntity;
  riserFlowSelection!: GuruEntity;
  returnAirStyleSelection!: GuruEntity;
  outsideAirSelection!: GuruEntity;
  supplyTypeSelection!: GuruEntity;
  outsideAirLocationSelection!: GuruEntity;
  opposedBladeDamperSelection!: GuruEntity;
  readonly handArrangementImagePath = signal<string>(undefined!);
  readonly pipeDetailImagePath = signal<string>(undefined!);
  isExpanded = true;
  private sectionKey = ConfigurationSection.MECHANICAL_CONNECTIONS;

  constructor() {
    this.isExpanded = !this.userStateService.isConfigurationSectionCollapsed(this.sectionKey);
  }

  ngOnChanges(): void {
    this.returnAirLocationSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USReturnLocation');
    this.paintOptionsSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USPaintOptions');
    this.topSupplySelection = SelectionUtils.getEntity(this.selectionEntities(), 'USSupplyTop');
    this.riserConnectionSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USRiserConn');
    this.riserFlowSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USRiserFlow');
    this.returnAirStyleSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USReturnAirOptions');
    this.outsideAirSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USOutsideAir');
    this.supplyTypeSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USSupplyType');
    this.outsideAirLocationSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USOutsideAirLocation');
    this.opposedBladeDamperSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USSupplyTypeOBD');
    this.modelService.executeHierarchy(this.engineKey(), 'hierDOC').subscribe(() => {
      this.modelService.getCharacteristicValue(this.engineKey(), 'UnitHandArrangementImage', 'FileName').subscribe(result => {
        this.handArrangementImagePath.set(this.imagePrefix() + result);
      });
      this.modelService.getCharacteristicValue(this.engineKey(), 'PipeDetailImage', 'FileName').subscribe(result => {
        this.pipeDetailImagePath.set(this.imagePrefix() + result);
      });
    });
  }

  selectionChanged(entity: GuruEntity, newValue: string): void {
    this.modelService.setValue(entity.Name, this.engineKey(), newValue).subscribe(() => this.valueChanged.emit());
  }

  toggleExpansion(): void {
    this.isExpanded = !this.isExpanded;
    this.userStateService.setCollapsedValue(this.sectionKey, this.isExpanded);
  }

  getExpansionIcon(): string {
    return this.isExpanded ? 'arrow_drop_up' : 'arrow_drop_down';
  }

  isInvalidSelection(entityName: string) {
    return this.invalidEntities() && this.invalidEntities().indexOf(entityName) >= 0;
  }

}
